import React, { useState , useEffect} from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import GraficoConsumo from "./GraficoConsumo";
import Conexao from "../../../../providers/Conexao";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export default function ModalGraficoConsumo(props){
    const {openPrevisao, setOpenPrevisao} = props
    const [data, setData] = useState([])


    useEffect(()=>{
        if(openPrevisao.open && openPrevisao.numeroserie !== ''){
            getData()
        }
    }, [openPrevisao])

    const getData = () =>{
        Conexao.get('coletasController/getDataNivelTonerGrafico?numeroserie='
            +openPrevisao.numeroserie+'&cor='
            +openPrevisao.cor+'&datapesquisa='
            +(openPrevisao.dataPesquisa ? openPrevisao.dataPesquisa : null)).then(response=>{
            if(response.status === 200 && response.data.status === 'OK'){
                setData(response.data.payload)
            }else{
                setData([])
            }
        }).catch(error=>{
            setData([])
        })
    }


    return <div >                                       
    
     <Dialog
         header={"Histórico de Consumo - "+openPrevisao.cor}
         visible={openPrevisao.open}         

         style={{ width: '60vw', }} // Largura padrão
         breakpoints={{ '960px': '75vw', '720px': '90vw' }} // Ajuste para telas menores
         onHide={() => setOpenPrevisao((prevData)=>[{
            open : false, 
            cor : '', 
            numeroserie : ''
         }])}
     >
        <GraficoConsumo
            data={data}
            cor={openPrevisao.cor} />
            <DataTable
                className='text-sm small-datatable'
                
                paginator
                rows={20} // Número de itens por página
                rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                responsiveLayout="scroll"
                value ={data}
            >
                <Column 
                    field="datalog"
                    header ='Data'
                    className="pt-2 pb-2"
                    headerStyle={{fontSize :'0.7rem',}}
                    bodyStyle={{fontSize :'0.7rem'}}
                />
                <Column 
                    field="horalog"
                    header ='Hora'
                    className="pt-2 pb-2"
                    headerStyle={{fontSize :'0.7rem'}}
                    bodyStyle={{fontSize :'0.7rem'}}
                />
                <Column 
                    field="nivel"
                    className="pt-2 pb-2"
                    header ='Nível'
                    headerStyle={{fontSize :'0.7rem'}}
                    bodyStyle={{fontSize :'0.7rem'}}
                    body={(row)=><span>{row.nivel+'%'}</span>}
                />
                <Column 
                    field="numeroserieunidade"
                    header ='Nº Série'
                    className="pt-2 pb-2"
                    headerStyle={{fontSize :'0.7rem'}}
                    bodyStyle={{fontSize :'0.7rem'}}
                />

            </DataTable>
     </Dialog>
 </div>
}
            
            
            
            